import { render, staticRenderFns } from "./PrkNewMatrixModal.vue?vue&type=template&id=e5ec5924&"
import script from "./PrkNewMatrixModal.vue?vue&type=script&lang=js&"
export * from "./PrkNewMatrixModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports